import styled from 'styled-components';

export const TitleWrapper = styled.div`
  width: 100%;
`;

export const ChartWrapper = styled.div`
  width: 100%;
  height: 100%;
`;

export const Title = styled.div`
  display: flex;
  flex-direction: column;
`;
